module.exports = __webpack_public_path__ + "assets/images/emblem-full_plus_82d2e7fb511b4777d419193aba6b6df6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/emblem-full_plus.png
// module id = 224
// module chunks = 0